import { Component, Input, OnInit } from '@angular/core';
import { Tenant } from '../../../../model/tenant';
import { TenantsService } from '../../../../services/tenants.service';
import { TriggerRule } from '../../../../model/trigger-rule';

@Component({
  selector: 'app-tenant-trigger-rules',
  templateUrl: './tenant-trigger-rules.component.html',
  styleUrls: ['./tenant-trigger-rules.component.scss']
})
export class TenantTriggerRulesComponent implements OnInit {

  @Input()
  public tenant: Tenant;

  public triggerRules: TriggerRule[];
  public totalTriggerRules: number;
  public loadingTriggerRules: boolean;

  public rows = 10;
  public first = 0;

  constructor(private tenantsService: TenantsService) {}

  ngOnInit(): void {
    this.loadTriggerRules(this.first / this.rows, this.rows);
  }

  private loadTriggerRules(offset: number, limit: number): void {
    this.loadingTriggerRules = true;
    this.tenantsService.getTenantTriggerRules(this.tenant.uuid, offset, limit)
      .subscribe(response => {
        this.triggerRules = response.triggerRules.sort((a, b) => a.name > b.name ? 1 : -1);
        this.totalTriggerRules = response.triggerRules.length;
        this.loadingTriggerRules = false;
      });
  }

  onPageChange(event): void {
    this.loadTriggerRules(event.first / event.rows, event.rows);
  }

}
